/**
 * Query keys del dominio de Horario.
 *
 * Keys consistentes y serializables (`docs/frontend_conventions.md`, Datos). La
 * rejilla y los slots filtran por la sede activa (el backend lo hace vía
 * `X-Sede-Id`), así que cada key incluye la sede para **cachear por sede**: al
 * cambiar de sede, el horario se recarga (clave distinta) en vez de mostrar el de la
 * sede anterior. El flag `laser` distingue el horario normal del láser (endpoints
 * distintos); la rejilla incluye además el desplazamiento de semana, y el slot la
 * fecha/hora, de modo que cambiar cualquiera pide la combinación correspondiente sin
 * perder las demás en caché.
 */

/** Raíz de todas las queries de horario (para invalidación amplia). */
export const SCHEDULING_ROOT_KEY = ["scheduling"] as const;

/** Key de la rejilla semanal, segmentada por sede, modo (láser) y semana. */
export function scheduleQueryKey(
  sedeId: number | null,
  laser: boolean,
  weekOffset: number,
) {
  return ["scheduling", "grid", { sede: sedeId, laser, week: weekOffset }] as const;
}

/** Key del detalle de un slot, segmentada por sede, modo (láser) y fecha/hora. */
export function slotQueryKey(
  sedeId: number | null,
  laser: boolean,
  date: string | null,
  time: string | null,
) {
  return ["scheduling", "slot", { sede: sedeId, laser, date, time }] as const;
}
